<!--
 * @Author: WLL
 * @Date: 2020-04-14 12:07:43
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-07 17:16:40
 * @Description: 机构预测排行
 -->
<template>
  <div class="organization">
    <div class="organization_above">
      <FilterItem label="报告发布时间" :spacing="10">
        <SjAutoComplete
          @click.native="onFilterClick('报告发布时间')"
          v-model="timeRangeSelected"
          :options="timeRangeList"
          style="width: 170px;"
          @change="search"
        ></SjAutoComplete>
      </FilterItem>
      <FilterItem label="" :spacing="10" style="margin-left: 30px;">
        <SjAutoComplete
          class="title-selected"
          v-model="incomeSelected"
          :options="incomeOptions"
          @change="onTitleSelected"
        ></SjAutoComplete>
        <SjAutoComplete
          class="value-selected"
          @click.native="topTitleEvent()"
          v-model="averageReturnSelected"
          :options="incomeValueOptions[incomeSelected]"
          style="width: 170px;"
          @change="search"
        ></SjAutoComplete>
      </FilterItem>
      <FilterItem label="行业" :spacing="10" style="margin-left: 30px;">
        <SelectIndustry
          @click.native="onFilterClick('行业')"
          @secondChange="onSecondChanged"
          v-model="industrySelected"
          :type.sync="industryType"
          @change="search"
        ></SelectIndustry>
      </FilterItem>
    </div>
    <div class="organization_below horizontal_container">
      <SjCard
        class="horizontal_item"
        style="padding: 0 5px;"
        v-sj-loading="orgLoading"
      >
        <DisplayArea
          icon-class="icon_xh iconicon_ranking"
          icon-size="14px"
          icon-color="#FF5C47"
          :show-more="false"
          title="机构预测排行"
        >
          <common-table
            ref="orgTable"
            @order="onCommonTableOrder"
            :data="orgData"
            :columns="orgColumns"
            default-selected="TOP10DESC"
            :tableProps="orgProps"
            :scrollDisabled="totalPage !== 0 && totalPage < pageNo"
            @infiniteScroll="getMoreOrgData"
            @current-change="onCurrentChange"
          ></common-table>
        </DisplayArea>
      </SjCard>
      <SjCard class="horizontal_item">
        <div v-if="orgSelected" class="organization_container">
          <div class="organization_chart" v-sj-loading="orgChartLoading">
            <DisplayArea
              :title="orgSelected.COMPANYNAME"
              icon-class="icon_xh icongongsishendu1"
              icon-color="#399BFF"
              :showSplitline="false"
              icon-size="18px"
              :showMore="false"
            >
              <template v-slot:titleRight>
                <span class="organization_chart_info">
                  {{ orgChartLabel }}
                  <span class="organization_chart_info_value">{{
                    orgChartLastValue
                  }}</span>
                </span>
              </template>
              <Chart
                v-if="orgChartData && orgChartData.length"
                :options="orgChartOptions"
              ></Chart>
              <SjBlank v-else />
            </DisplayArea>
          </div>
          <div class="organization_report" v-sj-loading="orgReportLoading">
            <DisplayArea
              :title="`${orgSelected.COMPANYNAME}近期预测报告`"
              icon-class="icon_xh iconicon_document1"
              icon-size="18px"
              icon-color="#399BFF"
              :showMore="false"
            >
              <common-table
                :data="orgReportData"
                :columns="orgReportColumns"
                :tableProps="orgReportProps"
                @cell-click="reportClickWrapper"
                :scrollDisabled="
                  orgReportTotalPage !== 0 &&
                    orgReportTotalPage < orgReportPageNo
                "
                @infiniteScroll="getMoreOrgReportData"
              ></common-table>
            </DisplayArea>
          </div>
        </div>
        <SjBlank v-else />
      </SjCard>
    </div>
  </div>
</template>

<script>
import FilterItem from "@/components/FilterItem.vue";
import DisplayArea from "@/components/DisplayArea.vue";
import Chart from "@/components/Chart";
import SelectIndustry from "@/components/SelectIndustry";
import { timeRangeList, averageReturnList } from "@/utils/const";
import { dateSort, publishChartDateFormatter } from "@/utils";
import reportMixin from "@/views/mixins/reportMixin";
import isequal from "lodash.isequal";
import CommonTable from "@/components/CommonTable/index";

export default {
  mixins: [reportMixin],
  components: {
    CommonTable,
    FilterItem,
    DisplayArea,
    Chart,
    SelectIndustry
  },
  data() {
    return {
      timeRangeSelected: 3,
      listOrder: "TOP10DESC",
      timeRangeList,

      incomeSelected: "V_AVG",
      incomeOptions: [
        {
          value: "V_AVG",
          label: "平均收益率"
        },
        {
          value: "V_TOP",
          label: "Top10平均收益率"
        }
      ],
      incomeValueOptions: {
        V_TOP: averageReturnList,
        V_AVG: []
      },
      averageReturnSelected: "all",
      averageReturnList,

      industrySelected: [],
      industryType: "011",

      pageNo: 1,
      pageSize: 40,
      totalPage: 0,

      orgData: [],
      orgColumns: [
        {
          label: "排名",
          width: 60,
          center: true,
          align: "center",
          customRender: this.rankRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          center: true,
          customRender: this.agencyRender
        },
        {
          prop: "RPT_SUM",
          label: "推荐个股数量",
          width: 120,
          center: true,
          order: {
            asc: "SUMASC",
            desc: "SUMDESC"
          }
        },
        {
          prop: "TOP10",
          label: "Top10平均收益率",
          width: 150,
          helpText: "根据研报推荐个股计算所得",
          align: "right",
          center: true,
          order: {
            asc: "TOP10ASC",
            desc: "TOP10DESC"
          },
          customRender: this.renderIncome
        },
        {
          prop: "AVG_RATE",
          label: "平均收益率",
          helpText: "根据研报推荐个股计算所得",
          width: 120,
          center: true,
          align: "right",
          order: {
            asc: "AVGASC",
            desc: "AVGDESC"
          },
          customRender: this.renderIncome
        },
        {
          prop: "INFO_SUM",
          label: "发表研报数量",
          width: 100,
          center: true,
          align: "right"
        }
      ],
      orgProps: {
        "highlight-current-row": true,
        defaultSelection: 0
      },
      orgSelected: null,
      orgLoading: false,

      orgChartData: [],
      orgChartLoading: false,

      orgReportData: [],
      orgReportColumns: [
        {
          prop: "PUBLISHDATE",
          label: "日期",
          width: 80,
          center: true,
          formatter: this.publishDateFormatter
        },
        {
          prop: "SECURITYNAME",
          label: "股票",
          width: 80,
          center: true,
          customRender: this.stockRender
        },
        {
          prop: "REPORTTITLE",
          label: "标题",
          customRender: this.ellipsisRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          center: true,
          width: 80,
          customRender: this.agencyRender
        },
        {
          prop: "ALLRESEARCHER",
          label: "作者",
          center: true,
          width: 80,
          customRender: this.researcherRender
        },
        {
          prop: "EMRATINGNAME",
          label: "评级",
          width: 60,
          center: true,
          customRender: this.ratingRender
        }
      ],
      orgReportProps: {},
      orgReportLoading: false,

      orgReportPageNo: 1,
      orgReportPageSize: 40,
      orgReportTotalPage: 0,
      throttlingCount: 0
    };
  },
  computed: {
    orgChartLabel() {
      const { orgChartData } = this;
      let lastDate = "-";
      if (orgChartData.length) {
        lastDate = orgChartData[orgChartData.length - 1].V_TRDDATE;
      }
      return `推荐股票Top10  30日内复权收益率（${lastDate}）`;
    },
    orgChartLastValue() {
      const { orgChartData } = this;
      let lastValue = "-";
      if (orgChartData.length) {
        lastValue = `${
          orgChartData[orgChartData.length - 1].D_AVGTOP10_1MONTH
        }%`;
      }
      return lastValue;
    },
    orgChartOptions() {
      const { orgChartData } = this;
      return {
        grid: {
          left: 20
        },
        tooltip: {
          formatter: params => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.throttlingCount++;
            if (this.throttlingCount % 50 === 0) {
              window.sendEvent("view_chart", {
                chart_name: "机构推荐股票平均收益率折线图",
                upstream_page_title: "首页"
              });
            }
            const data = params[0];
            return `${data.axisValueLabel}<br/>${data.marker}${data.seriesName}：${data.value}%`;
          }
        },
        xAxis: {
          splitLine: {
            show: true
          },
          data: orgChartData.map(v => v.V_TRDDATE)
        },
        series: [
          {
            name: "复权收益率",
            type: "line",
            showSymbol: false,
            lineStyle: {
              color: "#dd021b",
              width: 1
            },
            data: orgChartData.map(v => v.D_AVGTOP10_1MONTH)
          }
        ]
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    onCommonTableOrder(order) {
      this.listOrder = order;
      this.getOrgList();
    },
    onTitleSelected() {
      this.averageReturnSelected = "all";
      this.search();
    },
    topTitleEvent() {
      const item = this.incomeOptions.find(
        item => item.value === this.incomeSelected
      );
      if (item) {
        this.onFilterClick(item.label);
      }
    },
    reportClickWrapper(params) {
      this.onReportClick(params, {
        upstream_page_type: "机构预测排行",
        upstream_page_modular: "近期预测报告"
      });
    },
    onExpandChanged(key, value, name) {
      this.onFilterClick("行业", name);
    },
    onSecondChanged(label) {
      this.onFilterClick("行业", label);
    },
    onFilterClick(first_screening, second_screening = "") {
      window.sendEvent("click_filter", {
        page_type: "机构预测",
        first_screening: first_screening,
        second_screening: second_screening
      });
    },
    init() {
      this.search();
    },
    search() {
      this.orgSelected = null;
      this.getOrgList();
    },
    async getOrgList() {
      this.pageNo = 1;
      this.totalPage = 0;
      this.orgData = [];
      this.getMoreOrgData(true);
    },
    async getMoreOrgData(init = false) {
      try {
        this.orgLoading = true;
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          V_MONTH: this.timeRangeSelected,
          order: this.listOrder,
          [this.incomeSelected]:
            this.averageReturnSelected === "all"
              ? null
              : this.averageReturnSelected
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        } else {
          Object.assign(params, {
            V_INDUCODE: this.industryType
          });
        }
        const { data, page } = await this.$apis.Org.getAgencyList(params);
        this.pageNo += 1;
        this.totalPage = page.totalPage;
        if (init) {
          this.orgData = data;
          if (data.length) {
            if (this.$refs.orgTable && this.$refs.orgTable.$refs.table) {
              this.$refs.orgTable.$refs.table.selection = 0;
              this.onCurrentChange(data[0], false);
            }
            const avg = Number.parseInt(data[0]["AVG_RATE"]);
            const step = (avg - (avg % 5)) / 5;
            this.incomeValueOptions.V_AVG = [0, 1, 2, 3, 4]
              .map(i =>
                Object.assign({
                  label: "≥" + i * step + "%",
                  value: i * step + "%"
                })
              )
              .reverse();
            this.incomeValueOptions.V_AVG.unshift({
              label: "全部",
              value: "all"
            });
          } else {
            this.orgSelected = null;
          }
        } else {
          data.forEach(v => {
            this.orgData.push(v);
          });
        }
      } finally {
        this.orgLoading = false;
      }
    },
    onCurrentChange(val, sendEvent = true) {
      if (!val) {
        return;
      }
      if (!isequal(this.orgSelected, val)) {
        this.orgSelected = val;
        this.getOrgChartData();
        this.getOrgReportData();
      }

      if (sendEvent) {
        window.sendEvent("click_machanism", {
          page_type: "机构预测",
          machanism_id: val.V_COMPANYCODE,
          machanism_name: val.COMPANYNAME
        });
      }
    },
    async getOrgChartData() {
      try {
        this.orgChartLoading = true;
        this.orgChartData = [];
        const { orgSelected } = this;
        const params = {
          V_COMPANYCODE: orgSelected && orgSelected.V_COMPANYCODE,
          // V_MONTH: this.timeRangeSelected,
          V_MONTH: 1,
          V_INDUCODE: this.industryType
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        const { data } = await this.$apis.Org.getRateLineData(params);
        data.sort((a, b) => dateSort(a.V_TRDDATE, b.V_TRDDATE));
        this.orgChartData = data.map(v =>
          Object.assign(v, {
            V_TRDDATE: publishChartDateFormatter(v.V_TRDDATE)
          })
        );
      } finally {
        this.orgChartLoading = false;
      }
    },
    async getOrgReportData() {
      this.orgReportPageNo = 1;
      this.orgReportTotalPage = 0;
      this.orgReportData = [];
      this.getMoreOrgReportData(true);
    },
    async getMoreOrgReportData(init = false) {
      try {
        this.orgReportLoading = true;
        const { orgSelected } = this;
        const params = {
          pageNo: this.orgReportPageNo,
          pageSize: this.orgReportPageSize,
          V_COMPANYCODE: orgSelected && orgSelected.V_COMPANYCODE,
          V_MONTH: this.timeRangeSelected,
          V_INDUCODE:
            (this.industryType + "").length > 3 ? this.industryType : null,
          V_INDUCODE_H:
            (this.industryType + "").length <= 3 ? this.industryType : null
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        const { data, page } = await this.$apis.Org.getAgencyReport(params);
        this.orgReportPageNo += 1;
        this.orgReportTotalPage = page.totalPage;
        data.forEach(v => {
          Object.assign(v, {
            COMPANYNAME: orgSelected && orgSelected.COMPANYNAME
          });
        });
        if (init) {
          this.orgReportData = data;
        } else {
          data.forEach(v => {
            this.orgReportData.push(v);
          });
        }
      } finally {
        this.orgReportLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.organization {
  display: flex;
  flex-direction: column;
  .organization_above {
    border-bottom: 1px solid @color-splitline-xh;
    padding: 12px 17px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .organization_below {
    flex: 1;
    min-height: 0;
    margin: 10px;

    .organization_container {
      height: 100%;
      box-sizing: border-box;
      padding: 5px;
      display: flex;
      flex-direction: column;

      .organization_chart {
        height: 240px;
        .organization_chart_info {
          .text("caption", "normal");
          margin-left: 10px;
          .organization_chart_info_value {
            margin-left: 5px;
            .text("caption", "up-xh", "medium");
          }
        }
      }

      .organization_report {
        margin-top: 20px;
        flex: 1;
        min-height: 0;
      }
    }
  }
}

.title-selected {
  /deep/.sj-autocomplete-inputWrapper {
    /deep/.sj-autocomplete-input {
      border-radius: 4px 0 0 4px;
      padding: 1px 0 1px 10px !important;
      width: 130px;
    }
  }
}

.value-selected {
  /deep/.sj-autocomplete-inputWrapper {
    /deep/.sj-autocomplete-input {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>
